export enum BodyPart {
    LeftHand = 'HandLeft',
    RightHand = 'HandRight',
    LeftForeArm = 'ForeArmLeft',
    RightForeArm = 'ForeArmRight',
    HandIndex4Right = 'HandIndex4Right',
}
